(function() {
  var $37a9487a8cb965d8$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("video-player")) customElements.define("video-player", class VideoPlayer extends HTMLElement {
      video=this.querySelector("video");
      primaryPlayButton=this.querySelector("[data-play]");
      customControls=this.querySelector("div[data-controls]");
      runningButton=this.customControls?.querySelector("[data-toggle-running]") || null;
      volumeButton=this.customControls?.querySelector("[data-toggle-volume]") || null;
      hideOnPlay=this.querySelectorAll("[data-hide]");
      observer;
      constructor() {
        super();
        this.updateControlState = this.updateControlState.bind(this);
      }
      play() {
        if (this.video.readyState) {
          this.stopAll();
          this.video.play();
        }
      }
      pause() {
        if (this.video.readyState) this.video.pause();
      }
      stop() {
        this.pause();
      }
      stopAll() {
        document.querySelectorAll("video-player").forEach(player => {
          if (player !== this) player.stop();
        });
      }
      setupIntersectionObserver() {
        const options = {
          root: null,
          rootMargin: "0px",
          threshold: .1
        };
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting && !this.video.paused) this.stop(); else if (this.video.hasAttribute("autoplay") && entry.isIntersecting) this.play();
          });
        }, options);
        this.observer.observe(this.video);
      }
      updateControlState(el1, state) {
        const spans = el1?.querySelectorAll("span");
        if (!spans.length) return;
        if (state) {
          spans[0].classList.remove("hidden");
          spans[1].classList.add("hidden");
        } else {
          spans[0].classList.add("hidden");
          spans[1].classList.remove("hidden");
        }
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      connectedCallback() {
        if (!this.video) return false;
        const hasAutoplay = this.video.hasAttribute("autoplay");
        this.updateControlState(this.runningButton, !hasAutoplay);
        this.updateControlState(this.volumeButton, !this.video.muted);
        this.primaryPlayButton?.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          this.play();
        });
        this.video.addEventListener("click", e => this.video.paused ? this.play() : this.stop());
        this.video.addEventListener("pause", () => {
          this.updateControlState(this.runningButton, true);
          if (this.customControls) {
            el.setAttribute("aria-hidden", "");
            this.customControls.classList.add("hidden");
          }
          this.hideOnPlay.forEach(el1 => {
            el1.style.display = "";
            el1.setAttribute("aria-hidden", "false");
          });
        });
        this.video.addEventListener("play", () => {
          this.updateControlState(this.runningButton, false);
          if (this.customControls) this.customControls.classList.remove("hidden");
          this.hideOnPlay.forEach(el1 => {
            el1.style.display = "none";
            el1.setAttribute("aria-hidden", "true");
          });
        });
        this.video.addEventListener("volumechange", () => {
          this.updateControlState(this.volumeButton, !this.video.muted);
        });
        this.runningButton?.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          this.video.paused ? this.play() : this.stop();
        });
        this.volumeButton?.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          this.video.muted = !this.video.muted;
        });
        this.setupIntersectionObserver();
      }
    });
  })();
})();